/**
 * Converts a value to a number.
 *
 * @param value Value to convert
 *
 * @returns Converted value
 */
export function convertToNumber(value: number | string): number {
    if (typeof value === 'string') {
        return parseFloat(value);
    }

    return value;
}
